import React from "react";
import EsquadGroup from '../../assets/imgs/logos/2025/esquadgroup_cinza.svg';
const Footer: React.FC = () => {

    return(
      <div className="footer m-0 p-0">
        <div className="container">
          <div className="row align-items-center flex-row d-flex justify-content-between ">
            <div className="col-4 col-lg-auto text-start"> 
              <ul className="list-inline list-inline-dots ml-0 mb-0">
                <li className="list-inline-item">
                  <a href="#" className="link-secondary">
                    TERMOS DE USO
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-4 col-lg-auto text-start"> 
              <ul className="list-inline list-inline-dots ml-0 mb-0">
                <li className="list-inline-item">
                    <img src={EsquadGroup}/>
                </li>
              </ul>
            </div>

            <div className="col-4 col-lg-auto mt-3 text-end ">
              <ul className="list-inline list-inline-dots">
                <li className="list-inline-item">
                  <span className="copyright">
                    © {new Date().getFullYear()} - Desenvolvido por{" "}
                    <a href="http://www.alumisoft.com.br/" target="blank">
                      {" "}
                      Alumisoft Sistemas
                    </a>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
}

export default Footer;